import { Link } from "react-router-dom";

import ShowAllIcon from "@mui/icons-material/FormatListBulletedRounded";
import { Box, IconButton, Typography } from "@mui/material";

import { AppRoutes } from "@/router/AppRoutes";
import { useTranslation } from "@/translations";

import { AmbulanzCreationButton } from "./components/ambulanz-creation/AmbulanzCreationButton";

interface Props {
  count: number;
}

export function AmbulanzesHeader({ count }: Props) {
  const { t } = useTranslation();

  return (
    <Box
      px={2}
      py={0.5}
      bgcolor={"fsw.blue-5"}
      justifyContent={"space-between"}
      display={"flex"}
      alignItems={"center"}
      gap={2}
    >
      <Typography variant="h6" whiteSpace={"nowrap"}>
        {t("ambulanzes.title", { count })}
      </Typography>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <IconButton aria-label={t("ambulanzes.showAll")} component={Link} to={AppRoutes.Ambulanzes}>
          <ShowAllIcon />
        </IconButton>
        <AmbulanzCreationButton />
      </Box>
    </Box>
  );
}
